export const PLACE_ID = '63c806f4b5411539045fdc00';
// export const PLACE_ID = '63e4efb0d1ff153323d3bac6';
export const IMAGE_BASE_URL =
  'https://concierge.fra1.cdn.digitaloceanspaces.com/';
